import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    unit: {
      type: Array,
      default: function _default() {
        return new Array();
      }
    }
  },
  watch: {
    unit: {
      deep: true,
      immediate: true,
      handler: function handler(param) {
        this.unitList = param;
      }
    }
  },
  data: function data() {
    return {
      pageLoading: false,
      unitList: [{
        text: null
      }]
    };
  },
  methods: {
    updateProductUnit: function updateProductUnit() {
      var _this = this;

      _this.pageLoading = true;

      _this.$store.dispatch(PATCH, {
        url: "setting/product-unit",
        data: {
          product_unit: _this.unitList
        }
      }).then(function () {
        _this.$emit("close-dialog", true);

        _this.$emit("get-product-unit", true);
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    createProductUnit: function createProductUnit() {
      this.unitList.push({
        text: null
      });
    },
    deleteProductUnit: function deleteProductUnit(index) {
      if (this.unitList.length > 1) {
        this.unitList.splice(index, 1);
      }
    }
  },
  components: {
    Dialog: Dialog
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.lodash.toSafeInteger(document.body.clientWidth / 100 * 50);
    }
  }
};